import routes from "./routers";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  next();
  return;

  //if (to.matched.some(record => record.meta.requireAuth)) {}else{next();}
  const role = '';
  if (
    !role &&
    to.path !== "/login" &&
    to.path !== "/signup" &&
    to.path !== "/certCheck"
  ) {
    next("/login");
  } else if (to.meta.user) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    next();
    //role === 'admin' ? next() : next('/403');
  } else {
    next();
  }
});
router.afterEach(to => {
  //window.scrollTo(0, 0)
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js